import { ReactNode } from 'react';

import { Box, BoxProps } from '../../chakra';

export interface PageContainerProps extends Omit<BoxProps, 'paddingX' | 'paddingY'> {
  children: ReactNode;
  /**
   * Optionally add a nav component to the top of the page,
   */
  nav?: ReactNode;

  /**
   * If true, the content takes up the full browser width,
   * otherwise use a 2/3s view. False by default
   */
  widescreen?: boolean;
}

export const PADDING_X_WIDE = 8;
export const PADDING_X_MODERN = 5;
/**
 * With 16% padding on each side, the total padding will be 32%
 * which leaves the content taking up 68% (roughly two thirds) of the window
 **/
export const PADDING_X_NARROW = '16%';
export const PADDING_Y = 6;

export const PageContainer = ({ children, nav, widescreen = false, ...props }: PageContainerProps) => {
  return (
    <Box {...props} paddingY={PADDING_Y} paddingX={widescreen ? PADDING_X_WIDE : PADDING_X_NARROW}>
      {nav}
      {children}
    </Box>
  );
};
